import { jsx as t } from "react/jsx-runtime";
import { cn as m } from "@deputy-ai/common";
function n({ className: r, ...e }) {
  return /* @__PURE__ */ t(
    "div",
    {
      className: m("bg-primary/10 animate-pulse rounded-md", r),
      ...e
    }
  );
}
export {
  n as Skeleton
};
